/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type OnboardingPrivateCalendarSyncStepQueryVariables = {
    userId: string;
    orgId: string;
};
export type OnboardingPrivateCalendarSyncStepQueryResponse = {
    readonly org: {
        readonly " $fragmentRefs": FragmentRefs<"OnboardingPrivateCalendarSyncStep_org">;
    } | null;
    readonly user: {
        readonly " $fragmentRefs": FragmentRefs<"OnboardingPrivateCalendarSyncStep_user">;
    } | null;
};
export type OnboardingPrivateCalendarSyncStepQuery = {
    readonly response: OnboardingPrivateCalendarSyncStepQueryResponse;
    readonly variables: OnboardingPrivateCalendarSyncStepQueryVariables;
};



/*
query OnboardingPrivateCalendarSyncStepQuery(
  $userId: ID!
  $orgId: ID!
) {
  org: node(id: $orgId) {
    __typename
    ... on Org {
      ...OnboardingPrivateCalendarSyncStep_org
    }
    id
  }
  user: node(id: $userId) {
    __typename
    ... on User {
      ...OnboardingPrivateCalendarSyncStep_user
    }
    id
  }
}

fragment DataSourceCreate_org on Org {
  id
  primaryOrgCalendar
}

fragment DataSource_dataSource on DataSource {
  id
  name
  calendarIds
  syncTargets {
    emailAddress
    calendarId
  }
  state
  type
  username
}

fragment DataSource_org on Org {
  id
  domains
}

fragment OnboardingPrivateCalendarSyncStep_org on Org {
  id
  domains
  ...DataSource_org
  ...DataSourceCreate_org
}

fragment OnboardingPrivateCalendarSyncStep_user on User {
  id
  dataSources(first: 1000000) {
    edges {
      node {
        id
        state
        type
        name
        ...DataSource_dataSource
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgId"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "userId"
    } as any, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgId"
        } as any
    ], v3 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "userId"
        } as any
    ], v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "OnboardingPrivateCalendarSyncStepQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v2 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "OnboardingPrivateCalendarSyncStep_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "user",
                    "args": (v3 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "OnboardingPrivateCalendarSyncStep_user"
                                }
                            ],
                            "type": "User",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "OnboardingPrivateCalendarSyncStepQuery",
            "selections": [
                {
                    "alias": "org",
                    "args": (v2 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        (v5 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "domains",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "primaryOrgCalendar",
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "user",
                    "args": (v3 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v4 /*: any*/),
                        (v5 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1000000
                                        }
                                    ],
                                    "concreteType": "DataSourceConnection",
                                    "kind": "LinkedField",
                                    "name": "dataSources",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "DataSourceEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "DataSource",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "state",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "type",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "name",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "calendarIds",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "CrawlTarget",
                                                            "kind": "LinkedField",
                                                            "name": "syncTargets",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "emailAddress",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "calendarId",
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "username",
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "dataSources(first:1000000)"
                                }
                            ],
                            "type": "User",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "fee8edc22ade27a3e1bf63b970fde60e",
            "id": null,
            "metadata": {},
            "name": "OnboardingPrivateCalendarSyncStepQuery",
            "operationKind": "query",
            "text": "query OnboardingPrivateCalendarSyncStepQuery(\n  $userId: ID!\n  $orgId: ID!\n) {\n  org: node(id: $orgId) {\n    __typename\n    ... on Org {\n      ...OnboardingPrivateCalendarSyncStep_org\n    }\n    id\n  }\n  user: node(id: $userId) {\n    __typename\n    ... on User {\n      ...OnboardingPrivateCalendarSyncStep_user\n    }\n    id\n  }\n}\n\nfragment DataSourceCreate_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment DataSource_dataSource on DataSource {\n  id\n  name\n  calendarIds\n  syncTargets {\n    emailAddress\n    calendarId\n  }\n  state\n  type\n  username\n}\n\nfragment DataSource_org on Org {\n  id\n  domains\n}\n\nfragment OnboardingPrivateCalendarSyncStep_org on Org {\n  id\n  domains\n  ...DataSource_org\n  ...DataSourceCreate_org\n}\n\nfragment OnboardingPrivateCalendarSyncStep_user on User {\n  id\n  dataSources(first: 1000000) {\n    edges {\n      node {\n        id\n        state\n        type\n        name\n        ...DataSource_dataSource\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '6e93b0ac09c8fd9a72719d1bb36695b8';
export default node;
